// @flow
import * as React from "react";

import ReactDOM from "react-dom";
import VerticalBar from "../VerticalBar/VerticalBar";
import {
    AddressesFloatingContainer,
    AddressesFloatingContainerBottomRow,
    AddressesFloatingContainerTopRow
} from "./FloatingAddressContainerStyle";
import isEqual from "lodash/isEqual";

export type FloatingAddressRow = {
    children: React.Node,
    onClick?: () => void,
}

type OwnProps = {|
    topRow?: FloatingAddressRow,
    bottomRow?: FloatingAddressRow,
|};

type State = {|
    topRowHeight: number,
    bottomRowHeight: number,
|}

class FloatingAddressContainer extends React.Component<OwnProps, State> {
    updateRowsHeights: () => void;

    constructor(props: OwnProps) {
        super(props);
        this.updateRowsHeights = this.updateRowsHeights.bind(this);
    }

    updateRowsHeights() {
        if (this.props.topRow) {
            this.setState({
                topRowHeight: parseFloat(window.getComputedStyle(ReactDOM.findDOMNode(this.refs.topRowRef)).getPropertyValue("height")),
            });
        }
        if (this.props.bottomRow) {
            this.setState({
                bottomRowHeight: parseFloat(window.getComputedStyle(ReactDOM.findDOMNode(this.refs.bottomRowRef)).getPropertyValue("height")),
            });
        }

    }

    componentDidMount() {
        this.updateRowsHeights();
    }

    componentDidUpdate(prevProps: OwnProps, prevState: State, snapshot: State) {
        this.updateRowsHeights();
    }

    shouldComponentUpdate(nextProps: OwnProps, nextState: State, snapshot: State) {
        return (!isEqual(this.props, nextProps)) || (!isEqual(this.state, nextState));
    }

    render() {
        const showVerticalBar = !!this.props.topRow && !!this.props.bottomRow;
        const verticalBarStyle = {
            marginTop: this.state ? `-${this.state.topRowHeight / 2}px` : undefined,
            height: this.state ? `${(this.state.topRowHeight + this.state.bottomRowHeight) / 2}px` : undefined,
        };
        return (
            <AddressesFloatingContainer>
                {this.props.topRow && (
                    <AddressesFloatingContainerTopRow ref={"topRowRef"} onClick={this.props.topRow.onClick}>
                        {this.props.topRow.children}
                    </AddressesFloatingContainerTopRow>
                )}
                {showVerticalBar && (<VerticalBar style={verticalBarStyle}/>)}
                {this.props.bottomRow && (
                    <AddressesFloatingContainerBottomRow ref={"bottomRowRef"} onClick={this.props.bottomRow.onClick}>
                        {this.props.bottomRow.children}
                    </AddressesFloatingContainerBottomRow>
                )}

            </AddressesFloatingContainer>
        );
    }
}

export default FloatingAddressContainer;


// WEBPACK FOOTER //
// ./src/Components/FloatingAddressContainer/FloatingAddressContainer.js